'use strict';

import _ from 'lodash';

export default function() {
  var _element = null;
  return {
    controller: function($scope, $http, $sce, moment, $uibModal, $timeout) {
      'ngInject';

      $scope.skip = 0;
      $scope.moment = moment;
      $scope.currentTweets = [];

      var _skipFirstLoad = true;

      function _getTweets() {
        if($scope.skip < 0) {
          $scope.skip = 0;
          return;
        }
        if($scope.currentTweets.length > 0) {
          $scope.currentTweets.splice(0, 1);
        }

        var child = $(_element).children();
        child.height(child.height());

        $http({ url: '/api/pages/gettweets', method: 'POST', data: { username: $scope.element.data.username, hashtag: $scope.element.data.hashtag, skip: $scope.skip } })
          .then(function Success(result) {
            //Remove media urls
            _.each(result.data, function(item, index) {
              _.each(item.Media, function(media, index2) {
                item.FullText = item.FullText.replace(media.url, '');
              });
            });

            //Convert entity urls
            _.each(result.data, function(item, index) {
              item.ReadMore = false;
              _.each(item.Entities.Urls, function(url, index2) {
                item.FullText = item.FullText.replace(url.url, '');
                item.ReadMore = true;
              });
            });
            $scope.currentTweets.push({
              tweets: result.data
            });
            child.height("auto");
          }, function Fail(result) {
            console.log("GetLogos Failed: " + result);
          })
      }

      $scope.showTweet = function showTweet(tweet) {
        $uibModal.open({
          templateUrl: 'TweetPopup',
          size: 'sm',
          windowClass: 'TweetPopup',
          controller: function($scope, $uibModalInstance) {
            $scope.tweet = tweet;
          }
        });
      };

      $scope.$watch("[element.data.username, element.data.hashtag]", function() {
        _.debounce(_getTweets, 1000)();
      });

      $scope.$watch("skip", function() {
        if(_skipFirstLoad) {
          _skipFirstLoad = false;
        } else {
          $scope.oldtweets = $scope.tweets;
          _getTweets();
        }
      });
    },
    template: require('./tweets.html'),
    link: function(scope, element, attrs) {
      _element = element;
    }
  };
};



// WEBPACK FOOTER //
// ./sgcontenteditor/customElements/tweets.js